import React from "react";

const MaxDelayCauseAgency = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2220_5673)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#FFE4E6" />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.001 11.998C18.3726 11.998 20.2951 13.9206 20.2951 16.2922C20.2951 18.6639 18.3725 20.5864 16.001 20.5864C13.6293 20.5864 11.7068 18.6638 11.7068 16.2922C11.7068 13.9206 13.6294 11.998 16.001 11.998ZM20.6432 13.1556C21.2696 14.0812 21.6032 15.175 21.6032 16.2923C21.6032 19.3863 19.0947 21.8946 16.0007 21.8946C12.9068 21.8946 10.3984 19.3863 10.3984 16.2923C10.3984 13.1982 12.9068 10.6898 16.0007 10.6898V10.127L17.196 10.9458L16.0007 11.7646V11.2018C13.1893 11.2018 10.9102 13.481 10.9102 16.2923C10.9102 19.1036 13.1893 21.3828 16.0007 21.3828C18.8122 21.3828 21.0912 19.1037 21.0912 16.2923C21.0912 15.2694 20.7927 14.289 20.2192 13.4415L20.6432 13.1556ZM17.5203 15.0882L17.461 15.3094C17.3539 15.7087 16.7546 15.844 16.405 15.8906L16.1603 15.9232C16.0399 16.3725 15.9196 16.8217 15.7991 17.2707L16.7425 17.5235C16.7887 17.6381 16.8053 17.7568 16.7741 17.8738L16.4271 19.1683L14.1942 18.5699L14.541 17.2755C14.5723 17.1583 14.6461 17.0639 14.7434 16.9878L15.6863 17.2404C15.807 16.7914 15.9273 16.3422 16.0477 15.8929L15.8521 15.7424C15.5727 15.5272 15.1211 15.1104 15.2281 14.7111L15.3121 14.3974C15.6328 14.6426 16.0371 14.8431 16.4953 14.9659C16.8483 15.0606 17.1964 15.0991 17.5203 15.0882L17.5203 15.0882ZM17.3608 19.5662L16.9672 19.4608L17.3508 18.0285C17.5198 17.3981 17.0895 16.8458 16.6337 16.4653L16.6353 16.4596C17.2205 16.3571 17.8691 16.0955 18.0381 15.4643L18.422 14.0319L18.8155 14.1372L18.9331 13.698L14.7589 12.5795L14.6412 13.0187L15.0348 13.1241L14.6511 14.5565C14.4819 15.1877 14.9128 15.7383 15.3683 16.1197L15.3668 16.1258C14.7816 16.2279 14.133 16.49 13.9639 17.1209L13.5803 18.553L13.1866 18.4477L13.069 18.8871L17.2432 20.0055L17.361 19.5662L17.3608 19.5662ZM16.5279 19.3431L14.0194 18.6709L14.403 17.2386C14.4614 17.0207 14.627 16.8696 14.8305 16.7645C15.1149 16.6182 15.4168 16.5739 15.7284 16.5327L15.8849 15.9485C15.5207 15.6674 14.9487 15.202 15.0901 14.6743L15.474 13.2419L17.9826 13.9142L17.5989 15.3465C17.4577 15.8731 16.7353 15.991 16.2735 16.0529L16.1169 16.6364C16.4816 16.9171 17.0529 17.3833 16.9116 17.9109L16.5279 19.3431Z"
      fill="#961B01"
    />
    <defs>
      <filter
        id="filter0_d_2220_5673"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2220_5673"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2220_5673"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MaxDelayCauseAgency;
